import { Component, ElementRef, NgZone, OnInit, ViewChild } from '@angular/core';
import { User } from '../models/user';
import { userService } from '../services/users/user.service';
import { notifier } from '../services/helpers';
import { ViewportScroller } from '@angular/common';

@Component({
  selector: 'app-users',
  templateUrl: './users.component.html',
  styleUrls: ['./users.component.scss']
})


export class UsersComponent implements OnInit {
  @ViewChild('userModal', {static:false}) modal: ElementRef;
  @ViewChild('userForm', {static:false}) userForm: any;
  locations = ['Oldenzaal', 'Utrecht', 'Amsterdam', 'Esterwegen'];
  countries = ['NL', 'DE'];
  customerGroups = ['Admin', 'Mangel', 'Driver', 'extern', 'Logistic'];
  newUser: User;
  users: User[];
  selectedCustomerGroup: string;
  selectedLocation: string;
  selectedCountry: string;
  selectedChangeUserCustomerGroup: string;
  selectedChangeUserLocation: string;
  selectedChangeUserCountry: string;
  showUserDetail: boolean = false;
  changedUser: User;

  constructor(private userService: userService,private viewportScroller: ViewportScroller,  private ngZone: NgZone) { }

  ngOnInit() {
    this.selectedCustomerGroup = 'Mangel';
    this.selectedLocation = 'Oldenzaal';
    this.selectedCountry = 'NL';
    this.newUser = new User('','','','','','','NL');
    this.changedUser =new User('','','','','','','NL');
    this.userService.getUsers().subscribe(users => {
      this.users = users;
    })
  }

  scrollToTop() {
    window.scrollTo(0, 0);
  }

  showUser(user:any){

    this.changedUser = user;
    this.selectedChangeUserLocation = user.location;
    this.selectedChangeUserCountry = user.country || 'NL';
    this.selectedChangeUserCustomerGroup = user.roles;
    this.showUserDetail = true;
    this.scrollToTop();
  }

  addUser() {
    this.newUser.roles = this.selectedCustomerGroup;
    this.newUser.location = this.selectedLocation;
    this.newUser.country = this.selectedCountry || 'NL';
    this.userService.addUser(this.newUser).subscribe(res =>{
      notifier('gebruiker succesvol toegevoegd', 'save', 'info');
      this.resetData();
      this.showUserDetail = false;
      this.userService.getUsers().subscribe(users => {
        this.users = users;
      });
    },
    error => {
      notifier('Er is iets misgegaan, zorg dat alle velden gevuld zijn', 'error', 'danger');
      console.log(error)
    })
    }

    changePassword(userId){
      this.userService.changePassword(userId, this.changedUser.password).subscribe(res => {
        notifier('wachtwoord succesvol aangepast', 'save', 'info');
        this.changedUser.password = '';
      },
      error => {
        notifier('Er is iets misgegaan, wachtwoord is niet gewijzigd', 'error', 'danger');
        console.log(error)
      })
    }

    changeUserRoles(userId){
      this.userService.updateUserRoles(userId, this.selectedChangeUserCustomerGroup, this.selectedChangeUserLocation, this.selectedChangeUserCountry).subscribe(res => {
        notifier('gegevens succesvol aangepast', 'save', 'info');
        var user =this.users.find(x => x.username == this.changedUser.username);
        user.roles = this.selectedChangeUserCustomerGroup;
        user.location = this.selectedChangeUserLocation;
        user.country = this.selectedChangeUserCountry || 'NL';
      },
      error => {
        notifier('Er is iets misgegaan, wachtwoord is niet gewijzigd', 'error', 'danger');
        console.log(error)
      })
    }

    deleteUser(userId){
      if(confirm('Weet u zeker dat u deze gebruiker wilt verwijderen?')){
        this.userService.deleteUser(userId).subscribe(res => {
          notifier('gebruiker succesvol verwijderd', 'save', 'info');
          this.users = this.users.filter(user => user.id !== userId);
          this.showUserDetail = false;
          this.changedUser = new User('','','','','','','NL');
        },
        error => {
          notifier('Er is iets misgegaan, gebruiker is niet verwijderd', 'error', 'danger');
          console.log(error)
        })
      }
    }

  
    resetData() {
      this.newUser = new User('','','','','','','NL');
      this.newUser.username = '';
      this.newUser.password = '';
      this.newUser.firstName = '';
      this.newUser.lastName = '';
      this.newUser.roles = '';
      this.newUser.location = '';
      this.newUser.country = 'NL';
      this.selectedCustomerGroup = 'Mangel';
      this.selectedLocation = 'Oldenzaal';
      this.selectedCountry = 'NL';
      if (this.userForm) {
        this.userForm.resetForm();
      }
    }
}
